import initializeComponent from '../../Shared/react-initialize';
import HomePageSearchHero from './search_hero';

initializeComponent('HomePageSearchHero', HomePageSearchHero);
